import { Dialog, DialogParams } from "@app/core/dialog/domain/dialog";

interface MarketingMessageParams extends DialogParams {
  show: boolean;
  id: string;
  m_type: "personal" | "marketing";
  location: string[] | null;
}

/*
  This class is used to recived the backend data to open
  a marketing dialog.
*/
export class MarketingMessage extends Dialog {
  /* Required: Should dialog be shown to the user */
  show: boolean;
  id: string;
  m_type: "personal" | "marketing";
  location: string[] | null;

  constructor(params: MarketingMessageParams) {
    super(params);
    this.show = params.show;
    this.id = params.id ?? "default";
    this.m_type = params.m_type;
    this.location = params.location;
  }
}
